window.fjWidgets = window.fjWidgets || {};
window.fjWidgets.subscriptions = window.fjWidgets.subscriptions || {};

window.fjWidgets.subscriptions.initialize = function (productId) {
  let widgetId = `fj-widget-subscription-${productId}`;
  let widgetSelector = `#${widgetId}`;
  let widgetElement = document.getElementById(widgetId);

  async function addSubscriptionToCart() {
    // if enable_subscription is checked, add the membership sku to the cart
    const subscriptionWidgetInput = document.querySelector(
      `${widgetSelector} input[name='enable_subscription']:checked`
    );

    // const isSubscription = JSON.parse(subscriptionWidgetInput.value.toLowerCase());

    const isSubscription = ""

    if (isSubscription) {
      let sizeLabel;
      for (const span of widgetElement.parentNode.parentNode.querySelectorAll("span")) {
        if (span.textContent === "Size:" || span.textContent === "Ring Size:") {
          sizeLabel = span;
        }
      }

      let materialLabel;
      for (const span of widgetElement.parentNode.parentNode.querySelectorAll("span")) {
        if (span.textContent === "Material:") {
          materialLabel = span;
        }
      }

      const ringSize = sizeLabel.nextElementSibling.textContent;
      const material = materialLabel?.nextElementSibling?.textContent;
      const variant = getMembershipVariantByRingSize(ringSize, material);
      
      if (variant) {
        const SELLING_PLAN_ID = material === '925 Sterling Silver' ? window?.Shopify?.globals.sterlingCircleMembershipSellingPlanId : window?.Shopify?.globals.innerCircleMembershipSellingPlanId;

        // we have to do a slight delay here so that the main product variant is added to the cart first
        setTimeout(async () => {
          await addVariantToCart(variant.id, SELLING_PLAN_ID);
          await applyCouponCode(getGlobalMembershipCouponCode());
        }, 1000);
      }
    }
  }

  // add event listeners to the add to cart buttons
  document.querySelectorAll("#AddToCart").forEach(element => {
    element.addEventListener("click", addSubscriptionToCart);
  });

  let stickyAddToCartButton = document.getElementById("StickyAddToCart");
  if (stickyAddToCartButton) {
    stickyAddToCartButton.addEventListener("click", addSubscriptionToCart);
  }

  // this function applies the radio styles to the subscription widget
  function applyRadioStyles(_event) {
    const activeElement = document.querySelector(`${widgetSelector} input[name='enable_subscription']:checked`);
    const inactiveElement = document.querySelector(`${widgetSelector} input[name='enable_subscription']:not(:checked)`);
    const subscriptionDescription = document.getElementById(`${widgetId}-description`);

    if (activeElement.id === `${widgetId}-enabled`) {
      subscriptionDescription.classList.remove("tw-hidden");
    } else {
      subscriptionDescription.classList.add("tw-hidden");
    }

    const activeClasses = ["tw-border-black"];
    const inactiveClasses = ["tw-border-transparent"];

    activeElement.parentNode.parentNode.classList.add(...activeClasses);
    activeElement.parentNode.parentNode.classList.remove(...inactiveClasses);
    inactiveElement.parentNode.parentNode.classList.remove(...activeClasses);
    inactiveElement.parentNode.parentNode.classList.add(...inactiveClasses);
  }

  // add event listener to the subscription widget so that when it's changed we can apply the styles
  widgetElement.addEventListener("click", function (event) {
    if (event.target && event.target.matches("input[type='radio']")) {
      applyRadioStyles();
    }
  });

  // apply the radio styles initially
  applyRadioStyles();
};
